import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";

import './dropDownMenu.scss';

function DropDownPtPlus(props) {
  const [click, setClick] = useState(false);
  const dispatch = useDispatch();

  const ptPlusRequestsOrderCount = useSelector((state) => state.notificationCount?.ptPlusRequestsOrderCount)

  const handleClick = () => {
    let obj = {
      id: null,
      items: null
    };
    dispatch({ type: "REQUESTED_ID", payload: obj });
    setClick(!click);
  }
  const pageLanguageContents = props.content
  const userType = localStorage.getItem('accountType')
  let MenuItems;
  MenuItems = [
    {
      title: 'Pending Requests',
      path: '/ptplus-order-details',
      cName: 'dropdown-link',
      type: 'OrderDetails'
    },
    {
      title: 'Request Order',
      path: '/ptplus-request-order',
      cName: 'dropdown-link',
      type: 'OrderRequests'
    },
    {
      title: 'Request Pickup Order',
      path: '/ptplus-request-pickup-order',
      cName: 'dropdown-link',
      type: 'OrderRequests'
    }
  ]

  const onLinkClick = (type) => {
    if (type === 'OrderDetails') {
      let obj = {
        pageType: "PtPlusPage",
        expanded: "sideBar"
      }
      dispatch({ type: 'PT_PLUS_PAGE', payload: obj })
    }
    if (type === 'OrderRequests') {
      let obj = {
        pageType: "PtPlusPage",
        expanded: "sideBar"
      }
      dispatch({ type: 'PT_PLUS_PAGE', payload: obj })
      let obj1 = {
        id: null,
        items: null
      };
      dispatch({ type: "REQUESTED_ID", payload: obj1 });
    }
  };

  const notificationCountStyle = { position: 'absolute', right: '19px', top: '-38px', fontSize: '10px', background: "#3fb144", borderRadius: '50%', padding: '2px', height: '25px', width: '27px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0', color: '#fff', fontWeight: 'bold' }

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className={item.cName}
                // exact
                to={item.path}
                onClick={() => onLinkClick(item.type)}
              >
                <img
                  className="arrow-image"
                  src={HoverRightArrow}
                  alt="right-arrow"
                />
                {item.title}
                {item.title === 'Pending Requests' &&
                  <>
                    {ptPlusRequestsOrderCount > 0 && <div style={{ position: 'relative' }}><span style={notificationCountStyle}>{ptPlusRequestsOrderCount}</span></div>}
                  </>
                }
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownPtPlus;